export const toNumericValue = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const text = String(value ?? '').trim().replace(/[^\d,.-]/g, '');
  if (!text) return 0;

  const normalized = text.includes(',')
    ? text.replace(/\./g, '').replace(',', '.')
    : text.split('.').length > 2 || /^\d{1,3}\.\d{3}$/.test(text)
      ? text.replace(/\./g, '')
      : text;
  const number = Number(normalized);
  return Number.isFinite(number) ? number : 0;
};

export const formatNumberARS = (value = 0) => toNumericValue(value).toLocaleString('es-AR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatCurrencyARS = (value = 0) => `$ ${formatNumberARS(value)}`;
